<div class="toolbar-container">
  <app-copy-item-button></app-copy-item-button>
</div>
